'use client';

import { useEffect } from 'react';

export function TestStyleOverride() {
  useEffect(() => {
    if (!navigator.webdriver) return;

    const style = document.createElement('style');
    style.innerHTML = `
      * {
        transition: none !important;
        animation: none !important;
      }
      [class*="MuiFade"] {
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
  }, []);

  return null;
}
